export default function ProfileNotificationsIcon({
  className = "",
  onClick = null,
}) {
  return (
    <>
      <svg
        className={className}
        onClick={onClick}
        id="Capa_1"
        data-name="Capa 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 700 700"
      >
        <path
          d="M574.8,381.94c-6.64-13.38-16.37-25.35-28.14-34.6-9.47-7.44-15.13-18.13-15.54-29.35-.04-1-.08-2-.12-2.97-.76-18.3-2.54-61.15-19.6-102.28-17.3-41.72-46.2-72.32-84.5-89.88-11.8-30.86-41.73-52.84-76.69-52.87-34.96-.02-64.91,21.92-76.75,52.77-38.32,17.51-67.26,48.08-84.6,89.78-17.1,41.11-18.94,83.96-19.72,102.25-.04.98-.08,1.98-.12,2.99-.43,11.21-6.1,21.9-15.58,29.32-11.78,9.23-21.52,21.19-28.18,34.56-6.92,13.87-10.57,29.43-10.58,44.99-.03,55.77,45.31,101.18,101.09,101.21h24.45c1.86,26.41,13.02,50.96,31.9,69.85,20.76,20.79,48.38,32.25,77.76,32.27s57.02-11.41,77.8-32.17c18.9-18.87,30.09-43.41,31.98-69.8h24.45c55.78.05,101.18-45.31,101.21-101.08,0-15.56-3.62-31.13-10.52-45.01ZM349.91,583c-32.09-.02-58.58-24.04-62.47-55.08l125,.07c-3.93,31.03-30.44,55.02-62.53,55ZM484.14,481.04l-268.34-.16c-29.91-.02-54.14-24.27-54.12-54.18.01-17.3,8.13-32.7,20.76-42.6,20.04-15.71,32.57-39.07,33.55-64.51.03-.95.07-1.87.11-2.78,1.74-40.79,8.2-136.04,99.38-159.14-.29-1.81-.45-3.67-.45-5.56.01-19.4,15.75-35.12,35.15-35.11,19.4.01,35.12,15.75,35.11,35.15,0,1.89-.16,3.75-.45,5.56,91.16,23.21,97.5,118.47,99.2,159.26.04.91.08,1.83.11,2.78.94,25.44,13.45,48.82,33.47,64.55,12.61,9.92,20.71,25.32,20.7,42.62-.02,29.91-24.27,54.14-54.18,54.12Z"
          style={{ strokeWidth: "0px" }}
        />
        <path
          d="M412.44,528c-3.93,31.03-30.44,55.02-62.53,55s-58.58-24.04-62.47-55.08l125,.07Z"
          className="notifiaction-fill"
          style={{ strokeWidth: "0px" }}
        />
        <path
          d="M538.32,426.92c-.02,29.91-24.27,54.14-54.18,54.12l-268.34-.16c-29.91-.02-54.14-24.27-54.12-54.18.01-17.3,8.13-32.7,20.76-42.6,20.04-15.71,32.57-39.07,33.55-64.51.03-.95.07-1.87.11-2.78,1.74-40.79,8.2-136.04,99.38-159.14-.29-1.81-.45-3.67-.45-5.56.01-19.4,15.75-35.12,35.15-35.11,19.4.01,35.12,15.75,35.11,35.15,0,1.89-.16,3.75-.45,5.56,91.16,23.21,97.5,118.47,99.2,159.26.04.91.08,1.83.11,2.78.94,25.44,13.45,48.82,33.47,64.55,12.61,9.92,20.71,25.32,20.7,42.62Z"
          className="notifiaction-fill"
          style={{ strokeWidth: "0px" }}
        />
      </svg>
    </>
  );
}
